module.exports = __webpack_public_path__ + "img/defaultImage.440b9b23.jpg";